/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tld: NonNullable<unknown> }} Tld_Pricing_Move_UpInputs */

const id_tld_pricing_move_up = /** @type {(inputs: Tld_Pricing_Move_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Naikkan ${i?.tld}`)
};

const en_tld_pricing_move_up = /** @type {(inputs: Tld_Pricing_Move_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move ${i?.tld} up`)
};

/**
* | output |
* | --- |
* | "Move {tld} up" |
*
* @param {Tld_Pricing_Move_UpInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_move_up = /** @type {((inputs: Tld_Pricing_Move_UpInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Move_UpInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_move_up(inputs)
	return id_tld_pricing_move_up(inputs)
});